import React from "react";
import BenifitApp from "../components/BenifitApp";
import rest1 from "../assets/images/rest1.png";
import rest2 from "../assets/images/rest2.png";
import rest3 from "../assets/images/rest3.png";
import ClientTestimonial from "../components/ClientTestimonial";
import faqImage from "../assets/images/faq_img.webp";
import sec from "../assets/images/sec1.webp";
import Faq from "../components/Faq";
import MailBox from "../assets/icons/MailBox";
import Call from "../assets/icons/Call";
import Rightarrow from "../assets/icons/Rightarrow";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";




const faqs = [
  {
    question: "How can restaurants sign up on LOADINN?",
    answer:
      "Go to our website, click on 'Become a Restaurant Partner,' fill out the form, purchase the subscription, and wait for approval. Once verified, your restaurant will be live on LOADINN.",
  },
  {
    question: "Is there an approval process before restaurants can start receiving orders?",
    answer:
      "Yes, LOADINN verifies all restaurant profiles before making them live on the platform.",
  },
  {
    question: "What subscription plans do you offer for restaurants?",
    answer:
      "We offer five different subscription plans. Please visit our website to check the details.",
  },
  {
    question: "Are there any additional charges beyond the subscription fee?",
    answer:
      "Each subscription plan includes a set number of orders. Beyond that limit, a platform fee is applied, which varies depending on the subscription. Additionally, a transaction fee is applied to each order via the payment gateway.",
  },
  {
    question: "Is there a fee for each order placed through the platform?",
    answer:
      "Yes, beyond the included orders in your subscription, a platform fee and a payment gateway transaction fee apply.",
  },
  {
    question: "How can restaurants update their menu on LOADINN?",
    answer:
      "Restaurants can update their menu themselves or contact us via chat or email for assistance.",
  },
  {
    question: "Can restaurants set different prices or special offers for online orders?",
    answer:
      "Yes, restaurants have full control over pricing and promotions.",
  },
  {
    question: "What happens if a restaurant wants to temporarily pause orders?",
    answer:
      "Restaurants can stop taking orders by switching to offline mode on the platform.",
  },
  {
    question: "Do restaurants need their own delivery staff, or does LOADINN provide couriers?",
    answer:
      "Restaurants do not need their own delivery staff. LOADINN provides all delivery services.",
  },
  {
    question: "How do restaurants track deliveries?",
    answer:
      "Restaurants do not have a direct delivery tracking system.",
  },
  {
    question: "What happens if a courier is delayed?",
    answer:
      "Restaurants can report delivery issues to LOADINN via chat support.",
  },
  {
    question: "How do restaurants receive payments for orders?",
    answer:
      "Payments are transferred directly to the restaurant’s bank account.",
  },
  {
    question: "How often are payouts made?",
    answer:
      "Payouts are processed daily.",
  },
  {
    question: "Are there any transaction fees deducted from the payouts?",
    answer:
      "Yes, a transaction fee is applied via our payment gateway, Stripe.",
  },
  {
    question: "What should restaurants do if they receive a fraudulent order or incorrect payment?",
    answer:
      "Restaurants should contact LOADINN support and report the issue immediately.",
  },
  {
    question: "How can restaurants contact LOADINN support?",
    answer:
      "Restaurants can reach our support team via chat.",
  },
];



const AddRestaurant = () => {
const { t } = useTranslation();
  const benefits = [
    {
      title: t("sign_up"),
      description: t("sign_up_description"),
      image: rest1,
    },
    {
      title: t("list_your_restaurant"),
      description: t("list_your_restaurant_description"),
      image: rest2,
    },
    {
      title: t("start_receiving_orders"),
      description: t("start_receiving_orders_description"),
      image: rest3,
    },
    {
      title: t("grow_with_loadinn"),
      description: t("grow_with_loadinn_description"),
      image: rest1,
    },
  ];

  return (
    <React.Fragment>
      <section className="rest_banner">
        <div className="wrapper">
          <div className="rest_bntext">
            <h1 className="usable_title">{t("add_your_restaurant_to_loadInn")}</h1>
            <p className="para_common">
              {t("join_our_network_and_reach_more_customers_today")}
            </p>
            <Link to="/add-restaurant/form" className="btn btn-secondary">{t("get_started")}</Link>
          </div>
        </div>
      </section>
      <section className="benifit_card_section">
        <div className="wrapper">
          <div className="benifit_grid">
            {benefits.map((benefit, index) => (
              <BenifitApp
                key={index}
                title={benefit.title}
                description={benefit.description}
                image={benefit.image}
              />
            ))}
          </div>
        </div>
      </section>
      <div className="launch_section_grid">
        <div className="launch_img">
                <img src={sec} alt="Launch Your Internet Ordering Business" />
        </div>
        <div className="bg_image_yellow launch_content">
            <h2 className="subtitle_common">
            {t("launch_your")} <span className="text-primary">{t("internet_ordering_business")}</span>
            </h2>
            <p className="para_common">
            {t("please_make_sure_the_paperwork_is_ready_for_a_seamless_signup")}
            </p>
            <ul className="launch_list">
                <li>{t("pvd_number")}</li>
                <li>{t("company_details")}</li>
                <li>{t("your_restaurant_menu")}</li>
                <li>{t("bank_account_details")}</li>
                <li>{t("representative_details")}</li>
            </ul>
        </div>
      </div>
      <ClientTestimonial />
      <section className="bg_image_yellow bg_cta_scs">
        <div className="wrapper">
          <div className="bg_cta_scs_cont">
            <h2 className="subtitle_common">
                {t("get")} <span className="text-secondary">{t("started")}</span>
            </h2>
            <p className="para_common">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
            
            <Link href="/add-restaurant/form" className="btn btn-secondary">{t("register_your_restaurant_now")}<Rightarrow /></Link>
          </div>
        </div>
      </section>
      <Faq faqs={faqs} faqimg={faqImage} />
      <section className="bg_image_yellow">
        <div className="wrapper">
          <div className="cta_grid">
            <div className="cta_title">
              <h2 className="subtitle_common">
                {/* Need{" "}
                <span className="text-primary">help?</span> */}
                      {t("need")} <span className="text-primary">{t("help")}</span>?

              </h2>
              <p className="para_common">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.
              </p>
            </div>
            <div className="cta_buttons">
                <Link href="mailto:example@gmail.com" className="btn btn-primary"><MailBox /> {t("email_ud")}</Link>
                <Link href="tel:9191919191" className="btn btn-primary"><Call /> {t("call_us")}</Link>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default AddRestaurant;
